<template>
	<view class="container">
		<view class="info-section">
			<image src="/assets/test.png" mode="aspectFit" class="device-image"></image>
			<view class="device-info">
				<text class="title">{{state.facilityName}}</text>
				<text class="sn">SN: {{state.facilityCode}}</text>
			</view>
			<view class="status-grid">
				<view class="status-item">
					<text class="status-label" style="color: #38b231;" v-if="state.isOnLine==1">在线</text>
					<text class="status-label" style="color: red;" v-else>离线</text>
				</view>
				<view class="status-item">
					<text class="status-label">太阳能 {{ state.dcInputVolt }}</text>
				</view>
				<view class="status-item">
					<text class="status-label">信号:{{state.rssi}}</text>
				</view>
			</view>
		</view>

		<view class="control-section">
			<text class="section-title">实时控制</text>
			<slider @change="handleControlChange" min="100" max="200" step="25" active-color="#007aff"
				:value="controlValue" style="width: 650rpx;
				 margin-left: 0rpx;
				 " />
			<view class="scale-labels">
				<text style="color: red;">关</text>
				<text>125</text>
				<text>150</text>
				<text>175</text>
				<text style="color: #38b231;
				margin-right: 10rpx;
				">开</text>
			</view>
		</view>
		<view class="log-section">
			<text class="section-title">设备操作记录</text>
			<view class="log-box">
				<text class="log-entry">{{ logEntry || '2025-01-01 19:06:12 开' }}</text>
			</view>
		</view>
		<button class="remove-btn" @click="removeSharedDevice">移除设备</button>
	</view>
</template>


<script setup>
	import {
		ref
	} from 'vue';
	import {
		getDeviceInfoByDeviceId,
		deleteDevice,
		deviceControlInfo
	} from '@/api/index.js'

	const state = ref({})
	onload((option) => {
		// 执行根据openId获取设备信息的函数
		state.value = JSON.parse(decodeURIComponent(option.device));
		getDeviceInfoByDeviceId(state.value.facilityCode).then((res) => {
			state.value = Object.assign({}, res.data, JSON.parse(decodeURIComponent(option.device)));
		})
	})
	// 模拟数据
	const controlValue = ref(); // 后面估计会用到 
	const solarLevel = ref(100);
	const logEntry = ref('暂无操作记录');
	// 移除用户绑定设备的参数
	const temp = {
		facilityCode: state.value.facilityCode
	}
	// 传递实时控制的参数
	const controInfo = {
		sn: state.value.facilityCode,
		destinationPosition: 100
	}

	// 移除用户绑定的设备
	const removeSharedDevice = () => {
		deleteDevice(temp).then((res) => {
			if (res.code === 200) {
				// 删除成功 返回首页面
				uni.redirectTo({
					url: "/pages/layout/index"
				})
			} else {
				//删除失败 提示失败信息
				uni.showToast({
					title: '设备删除失败',
					icon: 'fail'
				})
			}
		})
	}
	// 实时控制设备状态
	const handleControlChange = (e) => {
		controInfo.destinationPosition = e.detail.value
		console.log(controInfo)
		// deviceControlInfo(controInfo).then((res)=>{
		// 	console.log(res);
		// })
	}
</script>


<style scoped lang="scss">
	.container {
		padding: 20rpx;
		background-color: #f5f5f5;
	}

	.info-section {
		background: white;
		border-radius: 12rpx;
		padding: 20rpx;
		margin-bottom: 20rpx;
	}

	.device-image {
		width: 100%;
		height: 300rpx;
		margin-bottom: 20rpx;
	}

	.device-info {
		margin-bottom: 30rpx;

		.title {
			font-size: 36rpx;
			font-weight: bold;
			display: block;
			text-align: center;
			margin-bottom: 10rpx;
		}

		.sn {
			font-size: 28rpx;
			color: #666;
			display: block;
			text-align: center;
		}
	}

	.status-grid {
		display: flex;
		justify-content: space-between;

		.status-item {
			flex: 1;
			text-align: center;
			padding: 15rpx;
			background: #f8f8f8;
			border-radius: 8rpx;
			margin: 0 5rpx;

			.status-label {

				font-size: 28rpx;
				color: #333;
			}
		}
	}

	.control-section {
		background: white;
		padding: 20rpx;
		border-radius: 12rpx;
		margin-bottom: 20rpx;

		.section-title {
			font-size: 32rpx;
			font-weight: bold;
			display: block;
			margin-bottom: 20rpx;
		}

		.scale-labels {
			display: flex;
			justify-content: space-between;
			margin-top: 10rpx;
			padding: 0rpx;
			color: #666;
			font-size: 26rpx;
		}
	}

	.log-section {
		background: white;
		padding: 20rpx;
		border-radius: 12rpx;

		.section-title {
			font-size: 32rpx;
			font-weight: bold;
			display: block;
			margin-bottom: 20rpx;
		}

		.log-box {
			height: 120rpx;
			padding: 15rpx;
			background: #f8f8f8;
			border-radius: 8rpx;

			.log-entry {
				font-size: 26rpx;
				color: #333;
				display: block;
			}
		}
	}

	.remove-btn {
		margin-top: 40rpx;
		background: #ff3b30;
		color: white;
		border-radius: 50rpx;
		font-size: 32rpx;
		height: 80rpx;
		line-height: 80rpx;
	}
</style>